<div class="app-container">
  <page-header [title]="''">
    <ng-container class="custom-title">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          {{ 'purchaseOrder.checkout.header' | translate }}
        </div>
        <div>
          <img src="../../../assets/img/purchase-orders-hs-logo.png" alt="" class="company-img" />
        </div>
      </div>
    </ng-container>
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="navigateBack()"
      ></btn>
    </ng-container>
  </page-header>
  <section class="content">
    <div class="row">
      <div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 pr-0">
        <div *ngIf="activeTab === 'common'">
          <div *ngIf="isEditModeEnabled" class="card">
            <div class="row">
              <div class="text-bold card-title mb-2 ml-2">
                {{ 'purchaseOrder.checkout.paymentAndBilling' | translate }}
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-0 pt-1">
                <form-row-select
                  [label]="'purchaseOrder.paymentType'"
                  [options]="payments"
                  [(ngModel)]="payment"
                  [required]="true"
                  [isSelectDisabled]="
                    !isEditModeEnabled ||
                    (purchaseOrder?.id > 0 &&
                      purchaseOrder?.status?.id !== 'new' &&
                      purchaseOrder?.status?.id !== 'draft')
                  "
                  #depot="ngModel"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-0 pt-1">
                <form-row-select
                  [label]="'purchaseOrder.shippingAddress'"
                  [options]="addresses"
                  [ngModel]="address"
                  (modelChange)="onAddressSelected($event)"
                  [bindToObject]="true"
                  [required]="true"
                  [isSelectDisabled]="
                    !isEditModeEnabled ||
                    (purchaseOrder?.id > 0 &&
                      purchaseOrder?.status?.id !== 'new' &&
                      purchaseOrder?.status?.id !== 'draft')
                  "
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0 pt-1">
                <form-row-textarea
                  [icon]="'far-note'"
                  [label]="'note'"
                  [rows]="1"
                  [inputDisabled]="!isEditModeEnabled"
                  [(model)]="purchaseOrderInfo.note"
                ></form-row-textarea>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="card" *ngIf="activeTab === 'common'">
            <div class="text-bold card-title mb-2 ml-2">{{ 'purchaseOrder.checkout.basket' | translate }}</div>
            <p *ngIf="!productList?.length" class="text-align-center">{{ 'no.items' | translate }}</p>
            <div *ngIf="productList?.length" class="table-responsive">
              <table class="table">
                <thead>
                  <tr *ngIf="isEditModeEnabled">
                    <th class="pl-0">{{ 'purchaseOrder.checkout.item' | translate }}</th>
                    <th class="text-nowrap text-left">{{ 'purchaseOrder.checkout.numberOfItems' | translate }}</th>
                    <th class="text-nowrap text-left">{{ 'purchaseOrder.checkout.pricePerItem' | translate }}</th>
                    <th class="text-nowrap text-right">{{ 'purchaseOrder.checkout.rowSum' | translate }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody *ngIf="isEditModeEnabled">
                  <tr
                    *ngFor="let item of productList"
                    [ngClass]="
                      item.status?.id === 'cancelled'
                        ? 'row-cancelled'
                        : item.quantity === item.quantityIn
                          ? 'colorGrey'
                          : item.quantityIn > 0 && item.quantityIn < item.quantity
                            ? 'colorYellow'
                            : ''
                    "
                  >
                    <td class="pl-1 text-left">
                      <div class="flex-gap-10 align-items-center">
                        <!--                    <div [photoGallery]="item.mainImage?.url"-->
                        <!--                         [photoGalleryCaption]="-->
                        <!--                  item.fullName + '<br>' + (item.code ?  ('product.code' | translate) + item.code : '') + '<br>' + (item.ean ? ('product.ean' | translate) + item.ean : '')"-->
                        <!--                    >-->
                        <div class="images-item">
                          <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                        </div>
                        <!--                    </div>-->
                        <div>
                          <a class="link-bold" target="_blank" [routerLink]="['/product', item.product]">{{
                            item.name
                          }}</a>
                          <div class="product-details flex-gap-5 flex-wrap">
                            <div *ngIf="item.code && item.code.length > 0">
                              {{ 'product.code' | translate }}:<span> {{ item.code }}</span>
                            </div>
                            <div *ngIf="item.ean && item.ean.length > 0">
                              {{ 'product.ean' | translate }}:<span> {{ item.ean }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ item.quantity }}
                    </td>
                    <td class="text-right text-line-1">
                      <div>
                        <div *ngIf="item.discount <= 0">
                          {{ item.purchasePriceWithVat | formatPrice: item.currency }}
                        </div>
                        <div *ngIf="item.discount > 0">
                          <small class="text-red text-strike">
                            {{ item.purchasePriceWithVat | formatPrice: item.currency }}
                          </small>
                        </div>
                        <div *ngIf="item.discount > 0">
                          {{ item.purchasePriceWithVatAndDiscount | formatPrice: item.currency }}
                          <!--                          {{-->
                          <!--                            item.purchasePriceWithVat - item.purchasePriceWithVat * (item.discount / 100)-->
                          <!--                              | formatPrice: item.currency-->
                          <!--                          }}-->
                        </div>
                        <div *ngIf="item.discount <= 0">
                          <small>
                            {{ item.purchasePrice | formatPrice: item.currency }}
                            {{ 'without-vat' | translate }}
                          </small>
                        </div>
                        <div *ngIf="item.discount > 0">
                          <small>
                            {{
                              item.purchasePrice - item.purchasePrice * (item.discount / 100)
                                | formatPrice: item.currency
                            }}
                            {{ 'without-vat' | translate }}
                          </small>
                        </div>
                      </div>
                    </td>
                    <td class="text-right text-line-1">
                      <div class="d-flex align-items-center justify-content-right">
                        <div>
                          <div *ngIf="item.discount <= 0">
                            {{ item.purchasePriceAllWithVat | formatPrice: item.currency }}
                          </div>
                          <div *ngIf="item.discount > 0">
                            <small class="text-red text-strike">
                              {{ item.purchasePriceAllWithVat | formatPrice: item.currency }}
                            </small>
                          </div>
                          <div *ngIf="item.discount > 0">
                            {{ item.purchasePriceAllWithVatAndDiscount | formatPrice: item.currency }}
                          </div>
                          <div *ngIf="item.discount <= 0">
                            <small>
                              {{ item.purchasePriceAll | formatPrice: item.currency }}
                              {{ 'without-vat' | translate }}
                            </small>
                          </div>
                          <div *ngIf="item.discount > 0">
                            <small>
                              {{ item.purchasePriceAllWithDiscount | formatPrice: item.currency }}
                              {{ 'without-vat' | translate }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div *ngIf="item.discount > 0" class="discount-badge">-{{ item.discount.toFixed(2) }}%</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 pr-0">
        <div class="card ml-2">
          <div class="row">
            <div class="text-bold card-title mb-2 ml-auto mr-2">{{ 'purchaseOrder.checkout.sums' | translate }}</div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="price-box">
                <table>
                  <tr class="border-bottom">
                    <td>
                      <div class="pt-1 pb-2">
                        {{ 'purchaseOrder.shipping' | translate }}
                      </div>
                    </td>
                    <td>
                      <div class="pt-1 pb-2 text-primary text-bold">
                        {{
                          shippingPrice === 0
                            ? ('purchaseOrder.freeShipping.free3' | translate)
                            : (shippingPrice | formatPrice: purchaseCurrencyFromCompany)
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="pt-2">
                        {{ 'price.sum.without.vat' | translate }}
                      </div>
                    </td>
                    <td class="text-right">
                      <div class="pt-2">
                        {{ priceSum | formatPrice: purchaseCurrencyFromCompany }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'price.vat' | translate }}</td>
                    <td class="text-right">
                      {{ priceWithVatSum - priceSum | formatPrice: purchaseCurrencyFromCompany }}
                    </td>
                  </tr>
                  <tr class="text-bold text-right">
                    <td>
                      <div class="pb-1">
                        {{ 'price.sum.with.vat' | translate }}
                      </div>
                    </td>
                    <td class="text-right">
                      <div class="pb-1 text-bigger">
                        {{ priceWithVatSum + shippingPrice | formatPrice: purchaseCurrencyFromCompany }}
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="discountsSum > 0">
                    <td></td>
                    <td>
                      <div class="discount-badge-sum text-center">
                        {{ 'price.sum.discounts.with.vat' | translate }}:
                        {{ discountsSum | formatPrice: purchaseCurrencyFromCompany }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="d-flex flex-row justify-content-end">
                <btn
                  [label]="'purchaseOrder.checkout.btnOrder' | translate"
                  [title]="'purchaseOrder.checkout.btnOrder' | translate"
                  [icon]="''"
                  [classes]="['btn-xl', 'btn-first', 'mt-3', 'btn-bigger']"
                  (click)="finalizePurchaseOrder()"
                ></btn>
              </div>
              <div class="info-text-price d-flex align-items-center flex-row justify-content-end">
                <p class="m-0">
                  {{ 'purchaseOrder.checkout.orderInfo' | translate }}
                </p>
                <i class="fal fa-info-circle"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <modal-qrcode #modalQr></modal-qrcode>
  <modal-address-create (onCreate)="onAddressCreated($event)" #modalAddressCreate></modal-address-create>
</div>
